import React from "react";
import { Route, Switch } from "react-router-dom";

import * as QueriesQL from "queries/view";
import ViewPublicSchema from "@common/schema/view/public";
import * as Section from "@repoflow/components/section";
import { Crumb } from "@repoflow/components/breadcrumb";

import * as ViewRoute from "./view";
import * as RemoveRoute from "./remove";

const LocalProvider = ({
  match: { params, params: { viewId } },
  children: Children,
}) => {
  const { base: parentBase, basepath: parentBasepath } = Section.useSectionContext();
  const base = `${parentBase}/${viewId}`;
  const basepath = `${parentBasepath}/:viewId`;

  // Keyed on the entity — the screen below seeds its editor state once, from the
  // view this route resolved.
  return (
    <Section.Provider
      key={viewId}
      schema={[...ViewPublicSchema]}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ params }) => (
        <Section.Query query={QueriesQL.get} variables={params} datapath={"views.get"}>
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
}

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}`} component={ViewRoute.Content} />
    </Switch>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { viewId } }) => (
        <>
          <Crumb to={`${base}`} label={viewId} />
          <Switch>
            <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
            <Route path={`${basepath}`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => (<><ViewRoute.Sidebar /></>);
